import { faExclamation, faInfo, faQuestion } from '@fortawesome/pro-solid-svg-icons';
import { Modal, ModalCloseButton, ModalFooter, NotificationDispatch } from '@tryhackme/thm-ui-components';
import { useState } from 'react';
import { RoomSubmissionAction } from 'src/common/enums/rooms';
import { useUpdateSubmissionMutation } from '../../submissions.slice';
import { roomActionDescriptions } from './modal.constants';
import { StyledButton, StyledFontAwesomeTooltipIcon, StyledModalDescription, StyledModalTitle, StyledTagIcon, StyledTooltipToast } from './modal.styles';
import type { StatusModalProps } from './modal.types';
export const StatusModal = ({
  action,
  triggerElement,
  roomCode,
  onClose,
  disableAction
}: StatusModalProps) => {
  const [updateSubmission] = useUpdateSubmissionMutation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const handleUpdate = async () => {
    if (disableAction) {
      setIsOpen(false);
      onClose();
      NotificationDispatch('warning', 'In order to execute this action you have to clear Release date.');
      return;
    }
    await updateSubmission({
      action,
      roomCode,
      comment: '',
      date: 0
    });
    setIsOpen(false);
    onClose();
  };
  return <Modal open={isOpen} triggerElement={triggerElement} onOpenChange={open => {
    setIsOpen(open);
    if (!open) {
      onClose();
    }
  }} data-sentry-element="Modal" data-sentry-component="StatusModal" data-sentry-source-file="status-modal.tsx">
      <StyledModalTitle data-sentry-element="StyledModalTitle" data-sentry-source-file="status-modal.tsx">
        {action === RoomSubmissionAction.REJECT || action === RoomSubmissionAction.CLEAR_DATE ? <StyledTagIcon $color="error" icon={faExclamation} /> : <StyledTagIcon icon={faQuestion} />}
        {roomActionDescriptions[action]?.title}
      </StyledModalTitle>
      <StyledModalDescription data-sentry-element="StyledModalDescription" data-sentry-source-file="status-modal.tsx">{roomActionDescriptions[action]?.description}</StyledModalDescription>
      {(action === RoomSubmissionAction.ACCEPT || action === RoomSubmissionAction.ACCEPT_NO_NOTIFICATION) && <StyledTooltipToast>
          <StyledFontAwesomeTooltipIcon icon={faInfo} />
          {roomActionDescriptions[action]?.tooltipText}
        </StyledTooltipToast>}
      <ModalFooter isSmall data-sentry-element="ModalFooter" data-sentry-source-file="status-modal.tsx">
        <ModalCloseButton text="Cancel" data-sentry-element="ModalCloseButton" data-sentry-source-file="status-modal.tsx" />
        <StyledButton
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onClick={handleUpdate} variant="solid" color={action === RoomSubmissionAction.REJECT || action === RoomSubmissionAction.CLEAR_DATE ? 'error' : 'primary'} data-sentry-element="StyledButton" data-sentry-source-file="status-modal.tsx">
          {roomActionDescriptions[action]?.buttonDescription}
        </StyledButton>
      </ModalFooter>
    </Modal>;
};